import React from 'react';
import CuadroListaEditable from '../edicion/CuadroListaEditable.js';
import * as Data from '../edicion/data/DataPersonaInformaciones.js';
import * as DTOs from '../edicion/DTOs/InformacionesPersonaDTOs.js';
import * as Funciones from '../edicion/funciones/FuncionesInformaciones.js';

const InformacionesPersona = (props) => {
  const idPersona = props.persona && props.persona.id;

  return (
    <CuadroListaEditable
      titulo="Informaciones"
      idPadre={idPersona}
      data={Data}
      dtos={DTOs}
      funciones={Funciones}
      ocultarSiVacio={true}
    />
  );
};

export default InformacionesPersona;
